<template>
  <v-card width="100%" flat>
    <v-card-text class="text-center text-h4" id="portfolio">Portfolio</v-card-text>
    <v-card flat width="60%" class="mx-auto" v-if="!$vuetify.breakpoint.mobile">
      <v-card-text class="text-center">
        <v-tabs fixed-tabs>
          <v-tab class="white--text">Development</v-tab>
          <v-tab class="white--text">Design</v-tab>
          <v-tabs-slider color="orange"></v-tabs-slider>
          <v-tab-item>
            <v-card-text>
              <v-row>
                <v-col v-for="(item, index) in portfolios" :key="index">
                  <v-card outlined flat class="rounded-lg" width="280">
                    <v-card-text>
                      <v-img
                        :src="require('@/assets/' + item.img)"
                        :lazy-src="require('@/assets/' + item.img)"
                        class="mx-auto rounded-lg"
                        height="150"

                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card-text>
                    <v-card-title>{{ item.title }}</v-card-title>
                    <v-card-subtitle class="text-left">{{
                      limitText(item.description)
                    }}</v-card-subtitle>
                    <v-card-actions class="">
                      <v-spacer></v-spacer>
                      <v-btn color="orange" text :href="item.link" target="_blank">
                        Visit
                      </v-btn>
                      <v-btn color="orange" text @click="item.show = !item.show">
                        Read More <v-icon right>mdi mdi-arrow-down-circle</v-icon>
                      </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                      <div v-show="item.show">
                        <v-divider></v-divider>

                        <v-card-text>
                          {{ item.description }}
                        </v-card-text>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-row>
                <v-col v-for="(item, index) in designs" :key="index">
                  <v-card outlined flat class="rounded-lg" width="280">
                    <v-card-text>
                      <v-img
                        :src="require('@/assets/' + item.img)"
                        :lazy-src="require('@/assets/' + item.img)"
                        class="mx-auto"
                        height="150"

                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card-text>
                    <v-card-title>{{ item.title }}</v-card-title>
                    <v-card-subtitle class="text-left">{{
                      limitText(item.description)
                    }}</v-card-subtitle>
                    <v-card-actions class="">
                      <v-spacer></v-spacer>
                      <v-btn color="orange" text :href="item.link" target="_blank">
                        Visit
                      </v-btn>
                      <v-btn color="orange" text @click="item.show = !item.show">
                        Read More <v-icon right>mdi mdi-arrow-down-circle</v-icon>
                      </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                      <div v-show="item.show">
                        <v-divider></v-divider>

                        <v-card-text>
                          {{ item.description }}
                        </v-card-text>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
    <v-card flat width="100%" class="mx-auto" v-if="$vuetify.breakpoint.mobile">
      <v-card-text class="text-center">
        <v-tabs fixed-tabs>
          <v-tab class="white--text">Development</v-tab>
          <v-tab class="white--text">Design</v-tab>
          <v-tabs-slider color="orange"></v-tabs-slider>
          <v-tab-item>
            <v-card-text>
              <v-card
                outlined
                flat
                class="rounded-lg mb-3 mx-auto"
                width="280"
                v-for="(item, index) in portfolios"
                :key="index"
              >
                <v-card-text>
                  <v-img
                    :src="require('@/assets/' + item.img)"
                    :lazy-src="require('@/assets/' + item.img)"
                    class="mx-auto rounded-lg"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
                <v-card-title>{{ item.title }}</v-card-title>
                <v-card-subtitle class="text-left">{{
                  limitText(item.description)
                }}</v-card-subtitle>
                <v-card-actions class="">
                  <v-spacer></v-spacer>
                  <v-btn color="orange" text :href="item.link" target="_blank">
                    Visit
                  </v-btn>
                  <v-btn color="orange" text @click="item.show = !item.show">
                    Read More <v-icon right>mdi mdi-arrow-down-circle</v-icon>
                  </v-btn>
                </v-card-actions>

                <v-expand-transition>
                  <div v-show="item.show">
                    <v-divider></v-divider>

                    <v-card-text>
                      {{ item.description }}
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-card
                outlined
                flat
                class="rounded-lg mb-3 mx-auto"
                width="280"
                
                v-for="(item, index) in designs"
                :key="index"
              >
                <v-card-text>
                  <v-img
                    :src="require('@/assets/' + item.img)"
                    :lazy-src="require('@/assets/' + item.img)"
                    class="mx-auto rounded-lg"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
                <v-card-title>{{ item.title }}</v-card-title>
                <v-card-subtitle class="text-left">{{
                  limitText(item.description)
                }}</v-card-subtitle>
                <v-card-actions class="">
                  <v-spacer></v-spacer>
                  <v-btn color="orange" text :href="item.link" target="_blank">
                    Visit
                  </v-btn>
                  <v-btn color="orange" text @click="item.show = !item.show">
                    Read More <v-icon right>mdi mdi-arrow-down-circle</v-icon>
                  </v-btn>
                </v-card-actions>

                <v-expand-transition>
                  <div v-show="item.show">
                    <v-divider></v-divider>

                    <v-card-text>
                      {{ item.description }}
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-card-text>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      limit: 40,
      portfolios: [
        {
          img: "vt.png",
          title: "IFM Virtual Tour",
          description:
            "IFM Virtual Tour is a web platform that allows users to explore the IFM campus virtually. The tour includes interactive maps, 360-degree panoramic views, and information about the different buildings and facilities on campus. It is a great way for prospective students, faculty, and staff to get a sense of the IFM campus before they visit in person.",
          link: "https://ifm-virtual-tour-web.web.app/",
          show: false,
        },
        {
          img: "rani.png",
          title: "Rani Dental clinic",
          description:
            "Rani Dental Clinic is a website that showcases the services that the clinic offers. The website includes information about the clinic's dentists, hygienists, and other staff, as well as its hours of operation, location, and contact information. The website also features a gallery of before-and-after photos of patients who have undergone treatment at the clinic.",
          link: "https://rani-9ed60.web.app/#/",
          show: false,
        },
        {
          img: "minishop.png",
          title: "Mini Shop",
          description:
            "Mini Shop is an online platform that helps small businesses manage their finances and inventory. The platform provides businesses with tools to track their income and expenses, manage their inventory, and create invoices. Mini Shop also offers a variety of other features that can help businesses improve their efficiency and profitability",
          link: "https://mini-shop-default-technologies.web.app/#/",
          show: false,
        },
      ],
      designs: [
        {
          img: "massy.png",
          title: "Massy Bakery",
          description:
            "Massy Bakery is a bakery in Dar es Salaam, Tanzania that specializes in cakes. Their logo is a simple yet elegant design. The logo is in the brand's primary colors of maroon and golden yellow, and it is easy to remember and identify. The logo reflects the bakery's focus on quality and creativity.",
          link: "https://instagram.com/massy_bakery?igshid=OGQ5ZDc2ODk2ZA==",
          show: false,
        },
        {
          img: "veep.png",
          title: "Veepyolo Bakery",
          description:
            "Veepyolo Bakery is another bakery in Dar es Salaam, Tanzania that specializes in cakes. The logo reflects the bakery's focus on fun and creativity. The colors of the logo are bright and inviting, and they create a sense of excitement.",
          link: "https://instagram.com/veepyolo_bakery?igshid=MzRlODBiNWFlZA==",
          show: false,
        },
        {
          img: "iricious.png",
          title: "Iricious Lingerie",
          description:
            "Iricious Lingerie is a lingerie store in Dar es Salaam, Tanzania that sells a variety of lingerie and ornaments for men and women. Their logo is a simple yet elegant design that features a stylized woman's figure, and it creates a sense of sophistication. ",
          link: "https://instagram.com/iricious_lingerie?igshid=MzRlODBiNWFlZA==",
          show: false,
        },
      ],
    };
  },
  methods: {
    limitText(text) {
      if (text.length <= this.limit) {
        return text;
      } else {
        return text.substring(0, this.limit) + "...";
      }
    },
  },
};
</script>

<style></style>
